import { createSlice } from "@reduxjs/toolkit";

export const ShowHistoryTabModalSlice = createSlice({
    name: "showHistoryTabModal",
    initialState: {
        showHistoryTabModal: false,
    },
    reducers: {
        setShowHistoryTabModal: (state, action) => {
            state.showHistoryTabModal = action.payload;
        }
    }
})

export const { setShowHistoryTabModal } = ShowHistoryTabModalSlice.actions;

export default ShowHistoryTabModalSlice.reducer;



